export const tablePerformanseHeader = [
    { key: "number", value: "№"},
    { key: "name", value: "Название подрядчика"},
    { key: "spec", value: "Специализация"},
    { key: "legalForm", value: "Правовая форма"},
];
